export default __webpack_public_path__ + "static/media/notFound.88d11475.png";